import React from "react";
import MaintenanceLayout from "../shared/MaintenanceLayout";
import OcpiLogViewer from "./OcpiLogViewer";
import OcpiSubnav from "./OcpiSubnav";
import "../shared/maintenance-analytics.scss";
import "./ocpi.scss";

/** Every OCPI request and response, all partners, both directions (credentials tokens are never logged). */
const OcpiLogs: React.FC = () => (
  <MaintenanceLayout title="OCPI Roaming">
    <div className="ma">
      <OcpiSubnav />
      <OcpiLogViewer />
    </div>
  </MaintenanceLayout>
);

export default OcpiLogs;
